import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';

import Registration from '../Registration/Registration';
import Agenda from '../Agenda/Agenda';
import AboutConference from "../AboutConference/AboutConference";
import HonoraryPatronage from "../Partners/HonoraryPatronage";
import Partners from "../Partners/Partners";
import PartnersMain from "../Partners/PartnersMain";
import Speakers from '../Speakers/Speakers';
import Accomodation from '../Accomodation/Accomodation';

import "./MainContent.css"

function MainContent() {
  return (
    <>
      <Container id="main_container">
        <Row id="o_konferencji" className='flex-nowrap mainSection'>
          <br />
        </Row>
        <Row className='flex-nowrap justify-content-center mainSection'>
          <Col xs={12} sm={12} md={10} lg={10} xl={8}>
            <p>
              Drogie Przełyczki – Dzieci i Dorośli z atrezją przełyku,<br/>
              Drodzy Rodzice i Opiekunowie osób z atrezją przełyku,
            </p>
            <p>
              z wielką radością zapraszamy Was na I Konferencję zatytułowaną "Przełknijmy to razem!" zorganizowaną przez Polskie Stowarzyszenie Rodzin z Atrezją Przełyku, poświęconą rodzinom i osobom dotkniętym atrezją przełyku.
            </p>
            <p>
              Wydarzenie odbędzie się <b>9 maja we Wrocławiu</b> i będzie wyjątkową okazją do zdobycia aktualnej wiedzy, wsparcia w codziennych wyzwaniach związanych z tą wadą i wymiany doświadczeń. Jesteśmy przekonani, że Wasza obecność przyniesie Wam również wiele cennych znajomości.
            </p>
            <div>
              <p>Program będzie obejmował wystąpienia specjalistów, również rodziców Przełyczków w zakresie:</p>
              <ul>
                <li>chirurgii dziecięcej,</li>
                <li>gastroenterologii,</li>
                <li>genetyki,</li>
                <li>pulmonologii,</li>
                <li>psychologii,</li>
                <li>żywienia,</li>
                <li>fizjoterapii.</li>
              </ul>
              <p>Nie zabraknie również praktycznych warsztatów z udzielania pierwszej pomocy i fizjoterapii oddechowej. Aby dzień był radosny, na najmłodszych będą czekać atrakcje.</p>
            </div>
            <p>
              Serdecznie zapraszamy do wzięcia udziału w tym ważnym spotkaniu.
            </p>
            <p>
              Z wyrazami szacunku,<br/>
              <b><i>Zarząd Polskiego Stowarzyszenia Rodzin z Atrezją Przełyku</i></b>
            </p>
          </Col>
        </Row>
        <Row className='flex-nowrap mainSection mainSectionHeader'>
            <h2 id="section_partners">O KONFERENCJI</h2>
        </Row>
        <Row className='flex-nowrap mainSection'>
          <Col>
            <AboutConference />
          </Col>
        </Row>   
        <Row className='flex-nowrap mainSection mainSectionHeader'>
            <h2 id="section_partners">PATRONAT HONOROWY</h2>
        </Row>
        <Row className='flex-nowrap mainSection'>
          <Col>
            <HonoraryPatronage />
          </Col>
        </Row>  
        <Row className='flex-nowrap mainSection mainSectionHeader'>
            <h2 id="section_partners">PARTNERZY</h2>
        </Row>
        <Row className='flex-nowrap mainSection'>
          <Col>
            <PartnersMain />
          </Col>
        </Row> 
        <Row className='flex-nowrap mainSection'>
          <Col>
            <Partners />
          </Col>
        </Row> 
        <Row className='flex-nowrap mainSection mainSectionHeader'>
          <h2 id="program">PROGRAM KONFERENCJI</h2>
        </Row>
        <Row className='flex-nowrap mainSection'>
          <Col>
            <Agenda />
          </Col>
        </Row>
        <Row className='flex-nowrap mainSection mainSectionHeader'>
            <h2 id="wykladowcy">PRELEGENCI</h2>
        </Row>
        <Row className='flex-nowrap mainSection'>
          <Col>
            <Speakers />
          </Col>
        </Row>
        <Row className='flex-nowrap mainSection mainSectionHeader'>
            <h2 id="rejestracja">REJESTRACJA NA KONFERENCJĘ</h2>
        </Row>
        <Row className='flex-nowrap mainSection'>
            <Col>
              <Registration />
            </Col>
        </Row>   
        <Row className='flex-nowrap mainSection mainSectionHeader'>
            <h2 id="rejestracja">POLECANE NOCLEGI</h2>
        </Row>
        <Row className='flex-nowrap mainSection'>
            <Col>
              <Accomodation />
            </Col>
        </Row>   
        <Row id="section-contact" className='flex-nowrap mainSection'>
        </Row>    
      </Container>
    </>
  );
}

export default MainContent;
